<div class="page-header-row one-row">
    <button
        *ngIf="showReturnButton"
        class="page-header-back-button"
        mat-icon-button
        color="accent"
        (click)="zurVorherigenSeite()"
    >
        <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="headline" [style.fontSize]="small ? '1em' : '1.4em'" [style.marginTop.px]="titleOffsetTopPx">
        {{ ueberschrift }}
    </span>
    <span class="spacer"></span>
</div>
